module.exports = __webpack_public_path__ + "static/media/tour-home-icon.340fc5c5.svg";